import React, { useState } from "react";

// interface
import { BasicDetailsTypes } from "../../../data/myProfile";
import { Utils } from "helpers/utils";
import { generateGroupInviteCodeAsync, getGroupInviteCodeAsync } from "../../../api/chats";
import { setGroupInviteCode } from "../../../redux/profile2/p2_reducer";
import { useRedux } from "hooks";
import { createSelector } from "reselect";
import { UserTypes } from "api";
import { Tooltip } from "react-tooltip";

interface UserDescriptionProps {
  basicDetails: BasicDetailsTypes;
}

const UserDescription = ({ basicDetails }: UserDescriptionProps) => {
  // console.log('UserDescription:', basicDetails);

  const [isGenCode, setIsGenCode] = useState<boolean>(false);
  const { dispatch, useAppSelector } = useRedux();
  const stateData = createSelector(
    (state: any) => state.Profile2,
    (profile2) => ({
      userType: profile2.userType as UserTypes,
      groupInviteCode: profile2.groupInviteCode,
      webUserId: profile2.webUserId,
    })
  );
  const { groupInviteCode, userType, webUserId } = useAppSelector(stateData);

  const fnGenCodeClick = async () => {
    if (Utils.IsViewAsAlert()) return;
    
    setIsGenCode(true);
    generateGroupInviteCodeAsync(basicDetails?.userId)
      .then(result => {
        // console.log(result);
        if (result.success) {
          // fnSetMsg(false, "ประมวลผลสำเร็จ");
          //setGroupInviteCode(result.data);
          dispatch(setGroupInviteCode(result.data));
          // alert(result.data);
        } else {
          // fnSetMsg(true, result.message);
        }
        setIsGenCode(false);
      })
      .catch(error => {
        // fnSetMsg(true, (error as Exception).message);
        alert((error as Error).message);
        setIsGenCode(false);
        // console.log(error);
      });
  }

  const [tipCopyCodeOpen, setTipCopyCodeOpen] = useState<boolean>(false);
  const onCopyClick = async () => {
    if (groupInviteCode) {
      await navigator.clipboard.writeText(groupInviteCode);
      setTipCopyCodeOpen(true);
      setTimeout(() => { setTipCopyCodeOpen(false); }, 1000);
      // alert('copied');
      // fnSetMsg(false, "คัดลอกลงคลิปบอร์ดแล้ว");
    } else {
      // fnSetMsg(true, "ยังไม่มีรหัส, กรุณาสร้างรหัสก่อน");
    }
  }

  // console.log('basicDetails:', basicDetails);

  return (
    <>
      {/* <div className="text-muted">
        <p className="mb-4">
          {basicDetails && basicDetails.description
            ? basicDetails.description
            : "-"}
        </p>
      </div> */}

      <div className="text-muted"><p className="mb-4">รายละเอียด</p></div>

      <div>
        <div className="d-flex py-1">
          <div className="flex-shrink-0 me-3 user-description-caption"><i className="bx bxs-id-card align-middle text-muted"></i> ชื่อ</div>
          <div className="flex-grow-1">
            <p className="mb-0">
              {/* <span className="spn-user-id p-1 ml-1" >{basicDetails && basicDetails.userId ? basicDetails.userId : "n/a"}</span> */}
              {basicDetails && basicDetails.fullName ? basicDetails.fullName : "-"}
            </p>
          </div>
        </div>

        <div className="d-flex py-1">
          <div className="flex-shrink-0 me-3 user-description-caption"><i className="bx bxs-quote-single-left align-middle text-muted"></i> ไอดี</div>
          <div className="flex-grow-1">
            <p className="mb-0">
              {/* <span className="spn-user-id p-1 ml-1" > */}
              CID:{basicDetails && basicDetails.userId ? basicDetails.userId : ""}, WID:{webUserId}
              {/* </span> */}
            </p>
          </div>
        </div>

        <div className="d-flex py-1">
          <div className="flex-shrink-0 me-3 user-description-caption"><i className="bx bxs-analyse align-middle text-muted"></i> ประเภท</div>
          <div className="flex-grow-1">
            <p className="mb-0">
              <span className={"badge badge-soft-primary rounded p-1 ml-1 " + Utils.GetUserRoleBg(basicDetails?.userRole)}>{Utils.GetUserRoleText(basicDetails?.userRole)}</span>
              &nbsp;
              <span className={"badge badge-soft-primary rounded p-1 ml-1 " + Utils.GetUserTypeBg(basicDetails?.userType)}>{Utils.GetUserTypeText(basicDetails?.userType)}</span>
              {basicDetails?.isAdmin && (
                <>&nbsp;<span className="badge badge-soft-primary rounded p-1 ml-1 bg-danger">Admin</span></>
              )}
              {basicDetails?.isItSupport && (
                <>&nbsp;<span className="badge badge-soft-primary rounded p-1 ml-1 bg-info">IT Support</span></>
              )}
            </p>
          </div>
        </div>


        {userType == UserTypes.Employee && (
          <div className="d-flex py-1 align-items-center">
            <div className="flex-shrink-0 me-3 user-description-caption" ><i className="mdi mdi-alpha-c-box-outline"></i> รหัส</div>
            <div className="flex-grow-1 overflow-hidden">{groupInviteCode ?? "-"}</div>

            <div className="ms-auto">
              <span className="badge badge-soft-primary rounded p-1 ml-1 bg-primary hand" data-tooltip-id="tipCopyCode" data-tooltip-content="คัดลอกแล้ว" onClick={onCopyClick} >คัดลอก</span>
              <Tooltip id="tipCopyCode" isOpen={tipCopyCodeOpen} />
            </div>
            &nbsp;
            <div className="ms-auto">
              <span className="badge badge-soft-primary rounded p-1 ml-1 bg-danger hand" onClick={() => fnGenCodeClick()} >{isGenCode ? 'กำลังสร้าง' : 'สร้างรหัส'}</span>
            </div>
          </div>
        )}

        <div className="d-flex py-1">
          <div className="flex-shrink-0 me-3 user-description-caption"><i className="bx bx-envelope align-middle text-muted"></i> อีเมล์</div>
          <div className="flex-grow-1"><p className="mb-0">{basicDetails && basicDetails.email ? basicDetails.email : "-"}</p></div>
        </div>

        <div className="d-flex py-1">
          <div className="flex-shrink-0 me-3 user-description-caption"><i className="bx bx-wallet-alt align-middle text-muted"></i> ตำแหน่ง</div>
          <div className="flex-grow-1 "><p className="mb-0 text-truncate">{basicDetails && basicDetails.positionName ? basicDetails.positionName : "-"}</p></div>
        </div>

        <div className="d-flex py-1">
          <div className="flex-shrink-0 me-3 user-description-caption"><i className="bx bxs-building-house align-middle text-muted"></i> บริษัท</div>
          <div className="flex-grow-1"><p className="mb-0">{basicDetails && basicDetails.companyName ? basicDetails.companyName : "-"}</p></div>
        </div>



        {/* <div className="d-flex py-2">
          <div className="flex-shrink-0 me-3">
            <i className="bx bx-message-rounded-dots align-middle text-muted"></i>
          </div>
          <div className="flex-grow-1">
            <p className="mb-0">
              {basicDetails && basicDetails.email ? basicDetails.email : "-"}
            </p>
          </div>
        </div>

        <div className="d-flex py-2">
          <div className="flex-shrink-0 me-3">
            <i className="bx bx-location-plus align-middle text-muted"></i>
          </div>
          <div className="flex-grow-1">
            <p className="mb-0">
              {basicDetails && basicDetails.location
                ? basicDetails.location
                : "-"}
            </p>
          </div>
        </div> */}
      </div>
    </>
  );
};

export default UserDescription;
